import { useState } from "react"

//to use this :
//1)
// const filterConfig = [
//     { key: "client", dataIndex: "client" },
//     { key: "product", dataIndex: ["product", "productName"] },
//     { key: "filterGroup", dataIndex: "filterGroup" },
//   ];

//2)   const [appliedFilters, setAppliedFilters, generateFilters] = useInteractiveTableFilters(data, filterConfig);
//3) Update table
// onChange={(pagination, filters) => {
// setAppliedFilters({
//     client: filters.client || [],
//     product: filters.product || [],
//     filterGroup: filters.filterGroup || [],
//   });
// }}

const useInteractiveTableFilters = (data, filterConfig) => {
  const [appliedFilters, setAppliedFilters] = useState(
    filterConfig.reduce((acc, curr) => ({ ...acc, [curr.key]: [] }), {})
  )

  const generateFilters = (filterKey, dataIndex) => {
    if (!data) return []
    let filteredData = [...data]

    Object.keys(appliedFilters).forEach((key) => {
      if (appliedFilters[key].length > 0 && key !== filterKey) {
        if (key === "product") {
          filteredData = filteredData.filter((item) =>
            appliedFilters[key].includes(item.product.productName)
          )
        } else {
          filteredData = filteredData.filter((item) => appliedFilters[key].includes(item[key]))
        }
      }
    })

    if (filterKey === "product") {
      return Array.from(new Set(filteredData.map((item) => item.product.productName)))
        .filter((item) => item)
        .map((filterValue) => ({ text: filterValue, value: filterValue }))
    }

    return Array.from(new Set(filteredData.map((item) => item[dataIndex])))
      .filter((item) => item)
      .map((filterValue) => ({ text: filterValue, value: filterValue }))
  }

  return [appliedFilters, setAppliedFilters, generateFilters]
}

export default useInteractiveTableFilters
